import { Component, inject, OnInit } from '@angular/core';
import { ModalComponent } from '../../../../services/modal/modal.component';
import { MODAL_DATA, MODAL_REF } from '../../../../services/modal/modal.service';
import { ButtonComponent } from '@infinitform/shared-ui';

export interface CADConfirmModalData {
  title: string;
  message: string;
}

@Component({
    selector: 'app-cad-confirm-modal',
    template: `
    <app-modal>
      <div class="if-modal-title">{{ data?.title || 'Confirm' }}</div>
      <div class="if-modal-content if-modal-content-center">
        <div class="confirm-message">{{ data?.message || 'Are you sure?' }}</div>
      </div>
      <div class="if-modal-actions">
        <app-button (click)="cancel()" variant="ghost">Cancel</app-button>
        <app-button (click)="confirm()" variant="primary">Confirm</app-button>
      </div>
    </app-modal>
  `,
    styles: [`
    .confirm-icon-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: 16px;
    }
    .confirm-icon {
      width: 48px;
      height: 48px;
      color: #f59e0b;
    }
    .confirm-message {
      text-align: center;
      font-size: 14px;
      line-height: 1.5;
      color: var(--black, #333);
    }
  `],
    imports: [ModalComponent, ButtonComponent]
})
export class CADConfirmModalComponent implements OnInit {
  private modalRef = inject(MODAL_REF);
  public data = inject<CADConfirmModalData>(MODAL_DATA, { optional: true });

  ngOnInit(): void {}

  confirm() {
    this.modalRef.close('confirm');
  }

  cancel() {
    this.modalRef.close('cancel');
  }
}

